module.exports = __webpack_public_path__ + "media/images/patent/zl_bg-07e2feb74c961f83942d626a2421371d.png";